import "codemirror/lib/codemirror.css";
import "codemirror/theme/monokai.css";
import "codemirror/addon/display/fullscreen.css";

import * as CodeMirror from 'codemirror';
import "codemirror/mode/javascript/javascript";
import "codemirror/addon/selection/active-line";
import "codemirror/addon/edit/matchbrackets";
import "codemirror/addon/display/fullscreen";
//代码折叠
import "codemirror/addon/fold/foldcode";
import "codemirror/addon/fold/foldgutter";
import "codemirror/addon/fold/brace-fold";
import "codemirror/addon/fold/comment-fold";
import "codemirror/addon/fold/foldgutter.css";
//括号匹配
import "codemirror/addon/edit/matchbrackets";
//自动补全
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/show-hint";
import "codemirror/addon/hint/anyword-hint";
import "codemirror/addon/hint/javascript-hint";


import { util } from "../../common/util";
import vConsole from "./codeMirrorConsole";

import "../../../scss/components/codeMirror.scss"

//判断是否忽略调用自动提示
const ignoreToken = (txtArray: Array<string>) => {
    if (txtArray.length === 1) {
        //tab
        if (txtArray[0] === "    ") {
            return true;
        } else {
            let curAscII = txtArray[0].charCodeAt(0);
            if (curAscII === 44) return false;// ,
            if ((curAscII > 47 && curAscII < 64) //数字
                || (curAscII > 59 && curAscII < 92) // < = > ?
                || (curAscII > 64 && curAscII < 92) // 大写字母
                || (curAscII > 94 && curAscII < 123) // _ && ` && 小写字母
                || (curAscII > 41 && curAscII < 48) //*+-./ !== ,
                || curAscII === 32 // 空格
                || curAscII === 36 // $
                || curAscII === 34 // "
                || curAscII === 39 // '
                ) {
                return false;
            }
            return true;
        }
    }
    return true;
}

//示例代码
const sampleCode = `//samples
let allLayerNames = vMap.getLayerNames();
if(allLayerNames.length>0){
    let layerName=allLayerNames[0];
    pInfo(layerName);
    pWarn("here is a warning:", layerName)
    let bufferOptions = {
        Distance: 10
    }
    let newLayerName = layerName+"_Buffer";
    
    let buffer = vMap.analysis["buffer"];  
    if(buffer){
        buffer(layerName,bufferOptions,newLayerName);
    }    
}`;

class VCode {
    constructor() {
        this.editor = null;
        this.hasInit = false;
    }

    editor: CodeMirror.EditorFromTextArea;
    hasInit: boolean;
    eval: any;
    tempConsole: any;

    //替换浏览器的console.*方法
    replaceConsole() {
        this.tempConsole = {
            log: console.log,
            info: console.info,
            debug: console.debug,
            warn: console.warn,
            error: console.error,
        };
        if (console) {
            let that = this;
            console.log = function (data: any) {
                // do sth
                vConsole.info(Array.prototype.slice.call(arguments, 0));
                //that.tempConsole.log.apply(this,
                //    Array.prototype.slice.call(arguments, 0));
            };

            console.info = function (data: any) {
                // do sth
                vConsole.info(Array.prototype.slice.call(arguments, 0));
                //that.tempConsole.info.apply(this, Array.prototype.slice.call(arguments, 0));
            };

            console.debug = function (data: any) {
                // do sth
                vConsole.info(Array.prototype.slice.call(arguments, 0));
                //that.tempConsole.debug.apply(this, Array.prototype.slice.call(arguments, 0));
            };
            console.warn = function (data: any) {
                // do sth
                vConsole.warning(Array.prototype.slice.call(arguments, 0));
                //that.tempConsole.warn.apply(this, Array.prototype.slice.call(arguments, 0));
            };

            console.error = function (data: any) {
                // do sth
                vConsole.error(Array.prototype.slice.call(arguments, 0));
                //that.tempConsole.error.apply(this, Array.prototype.slice.call(arguments, 0));
            };
        }
    }

    //重置浏览器的console.*方法
    resetConsole() {
        console.log = this.tempConsole.log;
        console.info = this.tempConsole.info;
        console.debug = this.tempConsole.debug;
        console.warn = this.tempConsole.warn;
        console.error = this.tempConsole.error;
    }

    init() {
        let config: any = {
            lineNumbers: true, // 显示行数
            indentUnit: 4, // 缩进单位为4
            styleActiveLine: true, // 当前行背景高亮
            matchBrackets: true, // 括号匹配
            mode: 'javascript', //'htmlmixed',     // HMTL混合模式
            lineWrapping: true, // 自动换行
            theme: 'monokai', // 使用monokai模版
            
            foldGutter: true,
            gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],

            //全屏模式
            fullScreen: false,
            
        };
        let dom: any = document.getElementById("codeMirror");
        this.editor = CodeMirror
            .fromTextArea(dom, config);

        this.editor.setOption("extraKeys", {
            // Tab键换成4个空格
            Tab: (cm: any) => {
                var spaces = Array(cm.getOption("indentUnit") + 1).join(" ");
                cm.replaceSelection(spaces);
            },
            // F11键切换全屏
            "F11": (cm: any) => {
                cm.setOption("fullScreen", !cm.getOption("fullScreen"));
            },
            // Esc键退出全屏
            "Esc": (cm: any) => {
                if (cm.getOption("fullScreen"))
                    cm.setOption("fullScreen", false);
            },
            //ctrl-space唤起智能提示
            "Ctrl-J": "autocomplete"
        });
        //任意键触发autocomplete
        this.editor.on("change", (edit: any, change: any) => {
            if (change.origin === "+input") {
                var text = change.text;
                let isIgnore = ignoreToken(text);
                if (!isIgnore) //不提示
                {
                    setTimeout(() => { edit.execCommand("autocomplete"); }, 20);
                }
            }
        });
        
        //向代码编辑器中写入代码
        this.editor.setValue(sampleCode);

        //将window.eval设置为null
        //window.eval = null;
        this.hasInit = true;
    }


    run() {
        if (this.hasInit) {
            let code = this.editor.getValue();

            let runCode = `try { 
                        ${code};
                        pInfo("success");
                    } catch (e) {
                        pWarn(e);
                    }
                    pInfo("Finished");`;
            //this.replaceConsole();

            util.eval(runCode);

            //this.resetConsole();
        }
    }

    clear() {
        this.editor.setValue("");
    }
}


export default VCode;